import { BASE_URL_API } from "constants/base-url-api";
import { RootHotel } from "containers/ListingDetailPage/listing-stay-detail/type";
import { getCookie } from "utils/functions-cookie";

export const fetchHotelDetails = async (
  destinationId: string,
  hotelId: string,
  checkin: string,
  nights: number,
  adults: number,
  children?: number,
  agesChildren?: number[]
) => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }
  const url = children 
    ? `${BASE_URL_API}/hotels/${destinationId}/${hotelId}?checkin=${checkin}&nights=${nights}&adults=${adults}&children=${children}&ages_children=${String(agesChildren)}` 
    : `${BASE_URL_API}/hotels/${destinationId}/${hotelId}?checkin=${checkin}&nights=${nights}&adults=${adults}`;
  const response = await fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }
  );

  const { detail, ...rest } = (await response.json()) as RootHotel;

  if (response.status !== 200) {
    throw new Error(detail);
  }

  return rest;
};
